export const formatCreatePrPf = (resp) => {
  let date_lud = new Date(Date.parse(resp.lud));
  return { ...resp, lud: date_lud }
}

